"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CardGroup;

var _react = _interopRequireDefault(require("react"));

require("./_style.scss");

function CardGroup(props) {
  var cards = props.children,
      titleChild = props.titleChild,
      actionChild = props.actionChild,
      _props$className = props.className,
      parentClasses = _props$className === void 0 ? "" : _props$className; // do I need to explicitly support the keys attribute? maybe

  var highlightClass = actionChild ? "has-actions" : "";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle__card-group ".concat(parentClasses, " ").concat(highlightClass)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle__card-group__header"
  }, titleChild, actionChild && /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle__card-group__header-actions"
  }, actionChild)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle__cards"
  }, cards));
}